import React, { useEffect, useState, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import AuthService from '../../services/authService';
import HomeRoutes from './routes';
import VerticalNavigation from '../../legacy-components/verticalNavigation';
import UnifiedAPIService, { UnifiedAPI } from '../../services/UnifiedAPIService';
import * as actions from "../../store/actions/actions";
import Header from '../../header/Header';
import { saveState } from 'store/sessionStorage';
import store from 'store/store';
import Footer from 'legacy-components/footer/Footer';
import { AuthorizationLoader } from './authorizationLoader';

interface RootState {
  auth: {
    user: {
      access_token?: string;
    } | null;
    loading: boolean;
  };
  userManager: any;
  common: {
    featuredApis: any;
  };
}

const Home: React.FC = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  
  const { user, loading } = useSelector((state: RootState) => state.auth);
  const userManager = useSelector((state: RootState) => state.userManager);

  const [state, setState] = useState({
    breadcrumb: { title: 'home', link: '/home' },
    isShowNav: true,
    isShowFullNav: true,
    isShowBanner: true,
  });

  const handleWindowClose = useCallback(() => {
    if (user?.access_token) {
      saveState(store.getState());
    }
  }, [user]);

  // Load metadata only after we have a valid token
  useEffect(() => {
    if (user?.access_token && !loading) {
      saveState(store.getState());

      // Load metadata
      UnifiedAPIService.get(UnifiedAPI.metadata)
        .then((response: any) => {
          dispatch({ type: actions.saveMetadata, request: response.data });
        })
        .catch((error) => {
          if(error.response?.status === 401 || error.response?.status === 0 ||
            error.response?.data?.status === 401 || error.response?.data?.status === 0
          ) {
             AuthService.login();
             return;
          }
        });
      // Setup window close handler
      window.addEventListener('onbeforeunload', handleWindowClose);
      return () => {
        window.removeEventListener('onbeforeunload', handleWindowClose);
      };
    }
  }, [user?.access_token, loading, dispatch, history, handleWindowClose]);

  const toggleNav = useCallback(() => {
    setState((prev) => ({
      ...prev,
      isShowNav: !prev.isShowNav
    }));
  }, []);

  const toggleNavSize = useCallback(() => {
    setState((prev) => ({
      ...prev,
      isShowFullNav: !prev.isShowFullNav
    }));
  }, []);

  // Don't render anything if we're still loading or don't have a user
  if (loading || !user?.access_token) {
    return null;
  }

  return (
    <React.Fragment>
      <Header toggleNav={toggleNav} toggleNavSize={toggleNavSize} />
      
      <main>
        <VerticalNavigation isShow={state.isShowNav} isShowFullSize={state.isShowFullNav} />
        <section className="main-content">
          {userManager?.id && (
            <div className="home-section">
              <HomeRoutes />
            </div>
          )}
          <Footer />
        </section>
      </main>

      <AuthorizationLoader />
    </React.Fragment>
  );
};

export default Home;
